import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';

import { ErrorPageComponent } from './components/error-page/error-page.component';
import { SurveyModule } from 'survey-angular-ui';
import { SurveyJsFormComponent } from './components/surveyjs-form.component';
import {
  MapPolygonQuestionComponent,
  registerMapPolygonQuestion,
} from './components/map-polygon-question/map-polygon-question.component';
import {
  RangeSelectQuestionComponent,
  registerRangeSelectQuestion,
} from './components/range-select-question/range-select-question.component';
import {
  PropertyTypologyQuestionComponent,
  registerPropertyTypologyQuestion,
} from './components/property-typology-question/property-typology-question.component';

@NgModule({
  declarations: [
    ErrorPageComponent,
    SurveyJsFormComponent,
    MapPolygonQuestionComponent,
    RangeSelectQuestionComponent,
    PropertyTypologyQuestionComponent,
  ],
  exports: [
    SurveyJsFormComponent,
    MapPolygonQuestionComponent,
    RangeSelectQuestionComponent,
    PropertyTypologyQuestionComponent,
  ],
  imports: [CommonModule, MaterialModule, SurveyModule],
})
export class SharedModule {
  constructor() {
    registerMapPolygonQuestion();
    registerRangeSelectQuestion();
    registerPropertyTypologyQuestion();
  }
}
